export const NOT_FOUND_STATUS = 404;
export const DENIED_STATUS = 403;
export const NOT_FOUND_TITLE = "404";
export const DENIED_TITLE = "403";
export const NOT_FOUND_SUB_TITLE =
  "Sorry, the page you visited does not exist.";
export const DENIED_SUB_TITLE = "Sorry, the page you visited is not available.";
export const BACK_HOME = "Back Home";
